export default __webpack_public_path__ + "static/media/ophthalmology.b29f359a.png";